<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="themeOptions.options().tooltips.backgroundColor" [sublabel]="'OPACITY'" [subinformation]="opacity + '%'">
  <div app-theme-option-content>
    <app-color-picker [itemColor]="color" [color]="backgroundColor" (sendColor)="receiveValue($event)"></app-color-picker>
  </div>
  <div app-theme-option-subcontent>
    <app-slider [color]="color" [value]="opacity" (sendValue)="receiveOpacity($event)"></app-slider>
  </div>
</app-theme-option>